import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/about', label: 'À Propos' },
    { path: '/services', label: 'Services' },
    { path: '/fleet', label: "Parc d'engins" },
    { path: '/projects', label: 'Réalisations' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-slate-900 text-white py-2 px-4 text-sm hidden md:block">
        <div className="container mx-auto flex justify-between items-center flex-wrap gap-2">
          <div className="flex flex-wrap gap-4 lg:gap-6 items-center">
            <a href="tel:+24174754771" className="flex items-center gap-2 hover:text-orange-400 transition-colors">
              <Phone size={14} />
              <span>(+241) 74754771</span>
            </a>
            <a href="tel:+24160456990" className="flex items-center gap-2 hover:text-orange-400 transition-colors">
              <Phone size={14} />
              <span>(+241) 60456990</span>
            </a>
            <a href="tel:+24165300284" className="flex items-center gap-2 hover:text-orange-400 transition-colors">
              <Phone size={14} />
              <span>(+241) 65300284</span>
            </a>
            <a href="mailto:contact@infraone.ga" className="flex items-center gap-2 hover:text-orange-400 transition-colors">
              <Mail size={14} />
              <span>contact@infraone.ga</span>
            </a>
          </div>
          <div className="text-slate-300">
            Zone Industrielle d'Oloumi, Libreville
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-white'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_3b5a5b49-403f-472e-808c-54358e33150f/artifacts/7pes589m_infraone_logo.png"
                alt="InfraOne Logo"
                className="h-16 w-auto md:h-20"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-base font-medium transition-colors relative group ${
                    isActive(item.path)
                      ? 'text-orange-500'
                      : 'text-slate-700 hover:text-orange-500'
                  }`}
                >
                  {item.label}
                  <span
                    className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-orange-500 transition-all duration-300 group-hover:w-full ${
                      isActive(item.path) ? 'w-full' : ''
                    }`}
                  />
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <Button
                asChild
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md transition-all duration-300 hover:shadow-lg"
              >
                <Link to="/contact">Demander un Devis</Link>
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-slate-700 hover:text-orange-500 transition-colors"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-200 shadow-xl">
            <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-base font-medium py-2 transition-colors ${
                    isActive(item.path)
                      ? 'text-orange-500'
                      : 'text-slate-700 hover:text-orange-500'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Button
                asChild
                className="bg-orange-500 hover:bg-orange-600 text-white w-full py-2 rounded-md"
              >
                <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                  Demander un Devis
                </Link>
              </Button>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;